export default {
  name: "NestedMenuItems",
  component: {
    NestedMenuItems: () => import("./index.vue")
  },
  props: {
    items: {
      type: Array,
      required: true
    }
  }
};
